import * as React from 'react';
import {FunctionComponent} from 'react';
import {Snippet} from '../../../../../Models/Snippet';
import {classNames} from '../../../../Support/classNames';
import {tableColumnTitles} from '../Utils/TableColumnTitles';
import {stringToColorHex} from '../Utils/stringToColorRgb';
import {Link} from 'react-router-dom';

interface OwnProps {
    selectedSnippetIds: number[];
    snippets: Snippet[];
    onChange: (snippetIds: number[]) => void;
    className?: string;
    onDeleteSnippet: (selectedSnippetId: number) => void;
}

export const SnippetSelector: FunctionComponent<OwnProps> = ({selectedSnippetIds, snippets, onChange, className, onDeleteSnippet}) => {
    const sortedSnippets = [...snippets].sort((a, b) => {
        return a.publicWorkout.executedAt.getTime() - b.publicWorkout.executedAt.getTime();
    });
    const titles = tableColumnTitles(sortedSnippets);

    return (
        <div className={classNames(className, 'card')}>
            <div className="card-title">
                <h5>Select workouts</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        {sortedSnippets.length > 0 && (
                            <ul className="list-unstyled">
                                {sortedSnippets.map((snippet, index) => {
                                    return (
                                        <li
                                            key={snippet.id}
                                            className="d-flex justify-content-start align-content-center snippet_report_list__snippet"
                                        >
                                            <div className="form-check mt-2 form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id={`snippet-${snippet.id}`}
                                                    checked={selectedSnippetIds.includes(snippet.id)}
                                                    onChange={() => {
                                                        if (selectedSnippetIds.includes(snippet.id)) {
                                                            onChange(
                                                                selectedSnippetIds.filter((id) => id !== snippet.id),
                                                            );
                                                        } else {
                                                            onChange([...selectedSnippetIds, snippet.id]);
                                                        }
                                                    }}
                                                />
                                                <div className="d-flex flex-row justify-content-start">
                                                    <label
                                                        className="form-check-label d-flex flex-row justify-content-start"
                                                        htmlFor={`snippet-${snippet.id}`}
                                                    >
                                                        <span
                                                            style={{
                                                                backgroundColor: stringToColorHex('' + snippet.id),
                                                                width: 10,
                                                                height: 10,
                                                                borderRadius: 10,
                                                                margin: 8,
                                                                display: 'block',
                                                            }}
                                                        />
                                                        <span>{titles[index]}</span>
                                                    </label>

                                                    <span className="d-flex justify-content-end align-items-center">
                                                        <Link to={'/snippets/' + snippet.id} >
                                                            <button className='btn btn-sm btn-link bi-chevron-right' />
                                                        </Link>
                                                        <button
                                                            className="btn btn-sm btn-link bi-trash snippet_report_list__action"
                                                            onClick={() => {
                                                                if (
                                                                    confirm(
                                                                        'Are you sure you want to delete this snippet?',
                                                                    )
                                                                ) {
                                                                    onDeleteSnippet(snippet.id);
                                                                }
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        {selectedSnippetIds.length === 0 && (
                            <p>
                                Build your report by adding workouts. You can also include workouts from your{' '}
                                <Link to="/crews">crewmates</Link>.
                            </p>
                        )}
                        <Link to="/workouts" className="btn-primary btn">
                            Browse Workouts
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
